// extracted by mini-css-extract-plugin
export default {"container":"Listening_container__YwmjP","audioPlayer":"Listening_audioPlayer__06GWG","playButton":"Listening_playButton__rEQB8"};